import axios, { AxiosRequestConfig } from 'axios';
import { getAuthToken } from '../components/security/AuthContext';

export const API_URL =
  process.env.REACT_APP_API_URL || 'https://cometai.ru/api';
export const WS_API_URL = process.env.REACT_APP_WS_URL || 'wss://cometai.ru/ws';

export const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Helper to construct full URL with base

export const apiRequest = async (
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
  url: string,
  data?: unknown
) => {
  const config: AxiosRequestConfig = {
    method,
    url: url, // Ensure the full URL is used
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getAuthToken()}`,
    },
    data, // Optional payload for POST/PUT
  };

  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as {
        response?: { status?: number; data?: { message?: string } };
      };
      if (axiosError.response?.status === 401) {
        localStorage.removeItem('authToken');
        window.location.href = '/login';
        return;
      }
      const message =
        axiosError.response?.data?.message ||
        'Server error occurred during the API request.';
      throw new Error(message);
    }
    const message =
      error instanceof Error
        ? error.message
        : 'Server error occurred during the API request.';
    throw new Error(message);
  }
};

export const checkHealth = async () => {
  await axiosInstance.get('/health');
};

export const getMe = async () => {
  const token = getAuthToken();
  if (!token) throw new Error('no token');
  const resp = await axiosInstance.get('/me', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return resp.data;
};
